import React, { Fragment, useEffect, useState } from "react";
import { ActivityIndicator, Image, View } from "react-native";
// import FastImage from "react-native-fast-image";
import { colors } from "../Shared";

interface Props {
  uri: string;
  maxHeight?: number;
}

export default function AutoSizeImage({ uri, maxHeight = 300 }: Props) {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [isLoading, setIsLoading] = useState(true);
  Image.getSize(uri, (width, height) => setSize({ width, height }));

  useEffect(() => {
    return;
  }, [size]);
  return (
    <Fragment>
      {isLoading && (
        <View
          style={{
            borderRadius: 3,
            marginBottom: 5,
            width: size.width ? size.width : "100%",
            height: size.height ? (size.height < 200 ? size.height : 200) : 50,
            maxWidth: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ActivityIndicator size="large" color={colors.bg.primary} />
        </View>
      )}
      <Image
        source={{ uri }}
        // resizeMode="contain"
        onLoadEnd={() => setIsLoading(false)}
        style={{
          borderRadius: 3,
          marginBottom: 5,
          marginHorizontal: "auto",
          width:
            size.height < maxHeight
              ? size.width
              : size.width * (maxHeight / size.height),
          height: size.height < maxHeight ? size.height : maxHeight,
          maxWidth: "100%",
        }}
      />
    </Fragment>
  );
}
